/**
 * Supported Produces response types
 */
export enum ResponseType
{
    Json,
    Text,
    Blob,
    BlobAndFilename,
    ArrayBuffer,
    LocationHeader,
    LocationHeaderAndJson
}
